// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__gkSCJ","col":"CardReaderDesc_col__2u-iA","label":"CardReaderDesc_label__1NRPh"};